import React from 'react';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import IconButtonWithPopOver from 'Theme/components/IconButtonWithPopOver';

interface Props {
    content: React.ReactNode;
    color?: "inherit" | "primary" | "secondary" | "action" | "disabled" | "error";
    role?: string;
    style?: React.CSSProperties;
}

function ContextualInfo({ content, color, role, style }: Readonly<Props>) {
    return (
        <div style={style} role={role}>
            <IconButtonWithPopOver
                customIcon={<InfoOutlinedIcon fontSize="small" color={color ?? "action"} />}
                description={content}
            />
        </div>
    );
}

export default ContextualInfo;
